import { useSelector } from 'react-redux';
import { AppState } from '../../../types/state/AppState';
import { useMemo } from 'react';
import { apiUtils } from '../../../utils';

export const useCompanyRegByUsers = () => {
    const users = useSelector((state: AppState) => state.companies.companies);
    return useMemo(() => apiUtils.normalize(users, (c) => c.createdById, (c) => c.createdBy),[users]);
}
